import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class SblockEventsComponent {
  showTitles = true;
  title = 'Próximos eventos';
  subtitle = 'Participa en nuestros encuentros y actividades formativas.';
  titlesColor = '#2B3892';
  secondaryColor = '#555555';
  buttonText = 'Ver todos los eventos';

  eventList = [
    {
      id: 1,
      businessImage: 'https://i.pravatar.cc/150?img=12',
      businessName: 'Adoratrices Madrid',
      heroImage: 'https://picsum.photos/seed/event-retiro/600/400',
      dateNumber: '14',
      month: 'jun',
      startTime: '09:00',
      endTime: '13:30',
      title: 'Retiro espiritual de verano',
      price: '25 €',
    },
    {
      id: 2,
      businessImage: 'https://i.pravatar.cc/150?img=25',
      businessName: 'Centro Educativo Kava',
      heroImage: 'https://picsum.photos/seed/event-taller/600/400',
      dateNumber: '21',
      month: 'jun',
      startTime: '17:00',
      endTime: '19:00',
      title: 'Taller de orientación familiar',
      price: 'Gratis',
    },
    {
      id: 3,
      businessImage: 'https://i.pravatar.cc/150?img=33',
      businessName: 'Comunidad Voluntariado',
      heroImage: 'https://picsum.photos/seed/event-jornada/600/400',
      dateNumber: '05',
      month: 'jul',
      startTime: '10:00',
      endTime: '14:00',
      title: 'Jornada de voluntariado social',
      price: '10 €',
    },
  ];

  btn1Active = true;
  btn1Es = 'Calendario completo';
  btn1Link = '#';
  btn1Align = 'center';

  btn2Active = true;
  btn2Es = 'Suscribirme';
  btn2Link = '#';
}
